import React, { Component } from 'react';
import Loading from "./Loading";
import './Button.scss';
import {cx} from '../lib/ClassSet';

class Button extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    if (!this.props.visible) return null;

    const { outline, icon } = this.props;

    let classes = cx({
      "Button": true,
      "s-active": this.props.active,
      "s-inactive": !this.props.active,
      "s-primary": this.props.primary,
      "s-secondary": !this.props.primary,
      "s-small": true,
      "s-link": this.props.link,
      "s-loading": this.props.showLoading,
      "s-outline": outline,
    })
    if (this.props.className) {
      classes = `${this.props.className} ${classes}`;
    }
    return (
      <div className={classes} onClick={this.handleClick} title={this.props.title}>
        <span className="label">{this.props.label}</span>
        { icon }
        <Loading show={this.props.showLoading} />
      </div>
    );
  }

  handleClick(e) {
    if (!this.props.active) return;
    e.preventDefault();
    e.stopPropagation();
    if (this.props.onClick) this.props.onClick();
  }
}

Button.defaultProps = {
  visible: true,
  active: true,
  primary: true,
  label: "Button",
  link: false,
  showLoading: false
}

export default Button;

